import classNames from "classnames";
import "./style.scss";

export interface OliverImageProps {
	id?: string;
	className?: string;
	style?: React.CSSProperties;
	wrapperStyle?: React.CSSProperties;
	src: string;
	alt?: string;
	backgroundColor?: string;
	highlight?: boolean;
}

const OliverImage: React.FC<OliverImageProps> = ({ id, className, style, wrapperStyle, src, alt, highlight }: OliverImageProps) => {

	return (
		<div className="oliver-image-wrapper" style={wrapperStyle}>
			<img 
				id={id} 
				src={src} 
				alt={alt} 
				className={classNames("oliver-image", { 
					highlighted: highlight, 
					[className as string]: className
				})}
				style={style}
				/>
		</div>
	);
};

export default OliverImage;
